import React, { useEffect, useRef, useState } from "react";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import "./features.css";
import arrowIcon from "../../assets/FeatureSection/arrow-icon.svg";
import cardImage1 from "../../assets/FeatureSection/AI Threat Intelligence.svg";
import cardImage2 from "../../assets/FeatureSection/Automated Security Controls.svg";
import cardImage3 from "../../assets/FeatureSection/Continuous AI Threat.svg";
import cardImage4 from "../../assets/FeatureSection/Compliance.svg";
import cardImage5 from "../../assets/FeatureSection/Incident Response.svg";
export default function Features() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const featurePoints = [
    {
      heading: "AI Threat Intelligence & Risk Analysis",
      paragraph:
        "Detect and prevent AI-specific attacks like adversarial manipulations and prompt injections.",
      image: cardImage1,
    },
    {
      heading: "Automated Security Controls Implementation",
      paragraph:
        "Enforce best-in-class security practices across AI models, infrastructure, and applications.",
      image: cardImage2,
    },
    {
      heading: "Continuous AI Threat Monitoring",
      paragraph:
        "Real-time scanning and anomaly detection for AI system vulnerabilities.",
      image: cardImage3,
    },
    {
      heading: "Compliance and Governance Alignment",
      paragraph:
        "Ensure AI regulatory adherence, from GDPR to AI-specific security frameworks.",
      image: cardImage4,
    },
    {
      heading: "Incident Response & Remediation",
      paragraph:
        "Automated security response mechanisms to contain and resolve AI security breaches.",
      image: cardImage5,
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(1);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      goToNextCard();
    }, 3000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [currentIndex]);

  const goToNextCard = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % featurePoints.length);
  };

  const goToPrevCard = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + featurePoints.length) % featurePoints.length
    );
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current && touchEndX.current) {
      const swipeDistance = touchEndX.current - touchStartX.current;
      if (swipeDistance > 50) {
        goToPrevCard(); // Swipe right -> Previous card
      } else if (swipeDistance < -50) {
        goToNextCard(); // Swipe left -> Next card
      }
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  const getCardPosition = (index) => {
    if (
      index ===
      (currentIndex - 1 + featurePoints.length) % featurePoints.length
    ) {
      return "left-card"; // Previous card
    }
    if (index === currentIndex) {
      return "center-card"; // Current card (on top)
    }
    if (index === (currentIndex + 1) % featurePoints.length) {
      return "right-card"; // Next card
    }
    return "hidden-card"; // Other cards (hidden)
  };

  return (
    <section
      className={`features-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="four"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Features</span>
          </div>
          <div className="heading-description">
            <h2>
              Secure AI Development and Deployment with Advanced AI Risk
              Mitigation
            </h2>
            <p>
              Explore SAIF Aviator's powerful security capabilities designed to
              fortify AI systems, ensuring trust, resilience, and compliance in
              AI-driven environments.
            </p>
          </div>
        </div>
        <div
          className="sliding-cards-container"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <img
            src={arrowIcon}
            alt="arrow-icon"
            className="arrow-icon-right"
            onClick={goToPrevCard}
          />
          <div className="feature-points-wrapper">
            {featurePoints.map((point, index) => (
              <div key={index} className={`card ${getCardPosition(index)}`}>
                <img src={point.image} alt="feature-icon" />
                <h3>{point.heading}</h3>
                <p>{point.paragraph}</p>
              </div>
            ))}
          </div>
          <img
            src={arrowIcon}
            alt="arrow-icon"
            className="arrow-icon-left"
            onClick={goToNextCard}
          />
        </div>
      </div>
    </section>
  );
}
